let video_id = 'e2df635eeef992b5389a4771cfe2ed3f';
let video = document.getElementById("cover-video");
let video_hls_src = "https://videodelivery.net/" + video_id + "/manifest/video.m3u8";

import './hls.min.js';
let Hls = require('./hls.min.js');

if (Hls.isSupported()) {
    let hls = new Hls();
    hls.loadSource(video_hls_src);
    hls.attachMedia(document.getElementById("cover-video"));
} else if (video.canPlayType('application/vnd.apple.mpegurl')) {
    console.log('HLS stream not supported')
    video.src = video_hls_src;
}
